// https://km.sankuai.com/collabpage/1503214914
const Statistics = Mach.requireModule('Statistics')

// 模块类型
enum PageLxType {
  PV = 'pv', // 页面PV，自动动上报pv， 不需要在页面重现时再次调用pv方法
  PVM = 'pvm', // 页面PV，手动上报pv， 需要在页面重现时再次调用pvm
  PD = 'pd', // 页面PD
}
enum ModuleLxType {
  MC = 'click', // 模块点击
  MV = 'view', // 模块曝光
  MVL = 'viewL', // 模块曝光，对应于客户端的MVL方式
  TAG = 'setTag', // 设置 tag 推荐在MC事件之前添加tag
}

const pageTracker = ({ type = PageLxType.PV, cid, valLab = {}, pageInfoKey }: { type?: PageLxType; cid: string; valLab?: Record<string, unknown>; pageInfoKey?: string }) => {
  if (type === PageLxType.PD) return Statistics[type]()
  return Statistics[type](cid, valLab, pageInfoKey)
}

const moduleTracker = ({ type = ModuleLxType.MC, cid, bid, tagKey, valLab = {} }: { type?: ModuleLxType; cid?: string; bid?: string; tagKey?: string; valLab?: Record<string, unknown> }) => {
  if (type === ModuleLxType.TAG) return Statistics[type](tagKey, valLab)
  return Statistics[type](cid, bid, valLab)
}

const order = (cid: string, bid: string, val: Record<string, unknown> = {}) => {
  Statistics.order(cid, bid, val)
}

export { PageLxType, ModuleLxType, pageTracker, moduleTracker, order }
